import React, { Component } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { Helmet } from 'react-helmet';
import BadgeForm from './BadgeForm';

class BadgesEdit extends Component {
  constructor(props) {
    super(props);
    this.state = { data: null, loading: true, notFound: false };
  }

  componentDidMount() {
    const id = this.props.match.params.id;
    firebase.firestore().collection('badgeDefinitions').doc(id).get().then(snap => {
      if (!snap.exists) {
        this.setState({ loading: false, notFound: true });
        return;
      }
      this.setState({ data: { id: snap.id, ...snap.data() }, loading: false });
    }).catch(() => this.setState({ loading: false, notFound: true }));
  }

  render() {
    const { data, loading, notFound } = this.state;
    const { history, match } = this.props;
    const id = match.params.id;

    if (loading) {
      return (
        <div style={{ padding: 20 }}>
          <Helmet><title>Edit Badge — BarZone</title></Helmet>
          <p>Loading...</p>
        </div>
      );
    }

    if (notFound) {
      return (
        <div style={{ padding: 20 }}>
          <Helmet><title>Badge Not Found — BarZone</title></Helmet>
          <p style={{ color: '#888' }}>Badge not found.</p>
          <button className="yellowBtn" onClick={() => history.push('/badges')}>Back to Badges</button>
        </div>
      );
    }

    return <BadgeForm initialData={data} docId={id} history={history} />;
  }
}

export default BadgesEdit;
